<template>
	<tr>
		<td
			class="align-middle"
			:style="{ 'max-width': '400px', height: '40px' }"
		>
			<h5
				class="text-overflow pointer"
				@click="$router.push({ name: 'postEdit', params: { id: data.id } })"
			>
				{{ data.name }}
			</h5>
		</td>
		<td class="align-middle font-weight-bolder" :style="{ 'min-width': '100px' }">
			<span v-if="discountValue">{{ discountValue }}</span>
			<span v-else>&nbsp;</span>
		</td>
		<td class="align-middle text-center">
			<template v-if="data.store">
				<img
					v-if="data.store[0].image_url"
					:src="data.store[0].image_url"
					:alt="data.store[0].name"
					:style="{ height: '40px', maxWidth: '80px', objectFit: 'contain' }"
				>
				<span v-else>
					{{ data.store[0].name }}
				</span>
			</template>
		</td>
		<td class="text-center align-middle" :style="{ width: '40px' }">
			<user-avatar :user="data.user" :size="40" />
		</td>
		<td class="align-middle" :style="{ 'min-width': '150px' }">
			<deal-status
				:value="data.status"
				class="mr-4"
				:options="['active', 'expired', 'draft', 'disabled']"
				@input="setStatus"
			/>
		</td>
		<td class="align-middle" :style="{ 'min-width': '130px' }">
			<a-tooltip placement="top">
				<template #title>
					<span>{{ $moment(data.created_at).format('LLL') }}</span>
				</template>
				<!--<b v-if="$moment().diff(data.created_at) > 0" class="text-uppercase text-muted mr-auto">{{ $moment(data.created_at).fromNow() }}</b>
				<b v-else class="text-uppercase text-danger mr-auto"><fa-icon :icon="['far','alarm-clock']" class="mr-2 animated pulse delay-1s infinite" />{{ $moment(data.created_at).fromNow() }}<span class="date-real">( {{ $moment(data.created_at).format('DD-MM HH:mm') }} )</span></b>-->
				<b
					v-if="$moment().diff(data.created_at) > 0"
					class="text-uppercase text-muted mr-auto"
				>{{ $moment(data.created_at).fromNow() }}</b>
				<b v-else class="text-uppercase text-danger mr-auto"><fa-icon
						:icon="['far', 'alarm-clock']"
						class="mr-2 animated pulse delay-1s infinite"
					/>{{ $moment(data.created_at).fromNow() }}
					<span class="date-real">(
						{{
							$moment(data.created_at).format('DD-MM HH:mm')
						}}
						)</span></b>
			</a-tooltip>
		</td>
		<td class="text-right align-middle" :style="{ 'min-width': '90px' }">
			<a-button
				size="small"
				@click="$router.push({ name: 'couponEdit', params: { id: data.id } })"
			>
				<fa-icon :icon="['fal', 'edit']" class="mr-2" /> Editar
			</a-button>
		</td>
	</tr>
</template>

<script>
export default {
	name: 'CouponTr',
	props: {
		data: {
			type: Object,
			required: true,
		},
		user: {
			type: [Object, Boolean],
			default: null,
		},
	},
	computed: {
		status() {
			return this.parser().dealStatus(this.data.status);
		},
		discountValue() {
			if (['%', '€'].some(d => d === this.data.discount_type)) {
				return this.data.discount_value + this.data.discount_type;
			}


			if (this.data.discount_type === 'free_shipping') {
				return 'Envío gratis';
			}

			return '';
		},
	},
	methods: {
		async setStatus(status) {
			const edit = await this.$sdk.deals().edit(this.data.id, { status });

			if (edit.ok) {
				// await this.$root.wordpress().status(this.data, status);

				this.$store.dispatch('setItem', {
					id: this.data.id,
					data: { ...this.data, status },
					type: 'posts',
				});
				this.$store.dispatch('setItem', {
					id: this.data.id,
					data: { ...this.data, status },
					type: 'pendingPosts',
				});

				this.$message.success(
					'Se modifico el estado del post correctamente',
				);
			}
		},
	},
};
</script>

<style lang="scss" scoped>
.date-real {
	color: #ff8200;
}
</style>
